/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

/**
 * Identifies the different examption options
 */
enum Exemption {
  Invalide = 'invalide',
  Maladie = 'maladie',
  SansObjet = 'sans-objet',
}

export default Exemption;
